import { render, staticRenderFns } from "./filter-box.vue?vue&type=template&id=4ea27120&scoped=true&"
import script from "./filter-box.vue?vue&type=script&lang=js&"
export * from "./filter-box.vue?vue&type=script&lang=js&"
import style0 from "./filter-box.vue?vue&type=style&index=0&id=4ea27120&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ea27120",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VBtn,VForm})
